import { NavigateFunction, Outlet, useNavigate } from 'react-router-dom';

// Auth0
import { Auth0Provider } from '@auth0/auth0-react';
import { PropsWithChildren } from 'react';

export const RIAuth0Provider = ({ children, navigate }: PropsWithChildren & { navigate?: NavigateFunction }) => {
  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN || ''}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID || ''}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      authorizationParams={{
        redirect_uri: import.meta.env.VITE_AUTH0_REDIRECT_URI || window.origin,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE
      }}
      onRedirectCallback={
        navigate
          ? (appState) => {
              navigate(appState && appState.returnTo ? appState.returnTo : window.location.pathname);
            }
          : undefined
      }
    >
      {children}
    </Auth0Provider>
  );
};

export const AuthProvider = () => {
  const navigate = useNavigate();
  return (
    <RIAuth0Provider navigate={navigate}>
      <Outlet />
    </RIAuth0Provider>
  );
};
